/**
 * Formata uma duração em segundos de forma compacta e legível.
 * Ex.: 90 → "1m", 3700 → "1h 1m", 90061 → "1d 1h".
 * Espelha o formatUptime usado na tela de appliances.
 */
export function formatDuration(seconds?: number | null): string {
    if (seconds == null || Number.isNaN(seconds)) return 'n/d';

    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes}m`;
    if (minutes > 0) return `${minutes}m`;
    return `${secs}s`;
}
